import React, { PropsWithChildren } from 'react'

import { LoaderOverlayWrapper } from './LoaderOverlayWrapper'
import LoaderWrapper, { LoaderWrapperProps } from './LoaderWrapper'

interface SmartLoaderWrapperProps extends Pick<
  LoaderWrapperProps,
  'minHeight' | 'loadWrapperClassName' | 'containerClassName' | 'loaderSize' | 'testid'
> {
  isLoading: boolean
  hasData: boolean
  overlayClasses?: string
}

/**
 * SmartLoaderWrapper - Intelligently switches between loader types based on data state
 *
 * - When loading with no data: Uses LoaderWrapper (hides empty content behind loader)
 * - When loading with data: Uses LoaderOverlayWrapper (shows loader overlay on existing content)
 * - When not loading: Renders children directly
 */
export const SmartLoaderWrapper: React.FC<PropsWithChildren<SmartLoaderWrapperProps>> = ({
  isLoading,
  hasData,
  children,
  minHeight,
  loadWrapperClassName,
  containerClassName,
  loaderSize,
  testid,
  overlayClasses,
}) => {
  if (isLoading && !hasData) {
    return (
      <LoaderWrapper
        showLoader
        minHeight={minHeight}
        loadWrapperClassName={loadWrapperClassName}
        containerClassName={containerClassName}
        loaderSize={loaderSize}
        testid={testid}
      >
        {children}
      </LoaderWrapper>
    )
  }

  if (isLoading && hasData) {
    return (
      <LoaderOverlayWrapper isLoading overlayClasses={overlayClasses}>
        {children}
      </LoaderOverlayWrapper>
    )
  }

  return <>{children}</>
}
